import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { If, Text, CTAButton, Format } from 'src/Components'
import { EMERGENCY_RESERVE } from 'src/constants/gems'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import history from 'src/history'
import { selectEmergencyReservePool } from 'src/store/selectors/home/equity'
import { selectShouldRenderEmergencyReserve } from 'src/store/selectors/display'

import styles from './MarketCash.module.scss'

const MarketCash = () => {
  const cashOutAmount = useSelector(selectEmergencyReservePool)
  const displayCashOut = useSelector(selectShouldRenderEmergencyReserve)

  const handleNavigateCashOut = () => {
    history.push(OVERLAY_HELPERS.cashout.buildPath(EMERGENCY_RESERVE))
  }

  return (
    <If condition={displayCashOut && cashOutAmount > 0}>
      <div className={styles.marketCash} data-qa='marketCash'>
        <Text size='l'>
          <FormattedMessage
            id='MarketSpotlight.marketCash'
            defaultMessage='Could you use some cash but don’t want to move?'
          />
        </Text>
        <div className={styles.marketCashOptions}>
          <CTAButton
            className={styles.marketCashOption}
            onClick={handleNavigateCashOut}
            data-qa='marketCashCashOut'
          >
            <FormattedMessage
              id='MarketSpotlight.marketCash.cashOut'
              defaultMessage="You've built enough equity to cash out around {cashOutAmount}"
              values={{
                cashOutAmount: (
                  <Text element='span' weight='semibold'>
                    <Format.Currency value={cashOutAmount} abbreviate />
                  </Text>
                )
              }}
            />
          </CTAButton>
        </div>
      </div>
    </If>
  )
}

export default MarketCash
